import { api } from '../api';
import { CheckoutPayResponse, CheckoutSession, CustomerRequest, PayWidget, Source } from '../models';

export const getCheckoutSession = (checkoutSessionId?: Uuid) => {
  return api.get<CheckoutSession>(`/checkouts/${checkoutSessionId || ''}`);
};

export const getPayWidget = (checkoutSessionId?: Uuid) => {
  return api.get<PayWidget>(`/paywidgets/${checkoutSessionId || ''}`);
};


export const payCheckout = (sources: Source[], checkoutSessionId?: Uuid, orderNote?: string, customer?: Partial<CustomerRequest>, recaptchaToken?: string) => {
  // Do single source / multiple source payments based on sources.
  if (sources.length > 1) {
    const requestPayload = {
      sources,
      customer,
      orderNote,
      recaptchaToken
    };

    return api.post<CheckoutPayResponse>(`/checkouts/${checkoutSessionId || ''}/multiPay`, requestPayload);
  }

  const { source, sourceType } = sources[0];

  const requestPayload = {
    source,
    sourceType,
    customer,
    orderNote,
    recaptchaToken
  };

  return api.post<CheckoutPayResponse>(`/checkouts/${checkoutSessionId || ''}/pay`, requestPayload);
};

export const payPayWidget = (sources: Source[], checkoutSessionId?: Uuid, total?: number, orderNote?: string, customer?: Partial<CustomerRequest>, recaptchaToken?: string) => {
  if (sources.length > 1) {
    const requestPayload = {
      sources,
      payWidgetAdditionalDetails: {
        customer,
      },
      orderNote,
      recaptchaToken,
    };
    return api.post<CheckoutPayResponse>(`/paywidgets/${checkoutSessionId || ''}/multiPay`, requestPayload);
  }

  const { source, sourceType, amount } = sources[0];

  const requestPayload = {
    source,
    sourceType,
    amount,
    orderNote,
    payWidgetAdditionalDetails: {
      customer,
    },
    recaptchaToken,
  };

  return api.post<CheckoutPayResponse>(`/paywidgets/${checkoutSessionId || ''}/pay`, requestPayload);
};

